
import {getToken} from '../adalConfig';

export const actionCreators = {

    // REQUEST_EVENTS 
    requestEvents: () => async (dispatch, getState) => {       
        dispatch({ type: 'REQUEST_EVENTS' });
        const headers = { Authorization: `Bearer ${getToken()}` };
        const url = `api/Events`;
        const response = await fetch(url, {headers});
        const events = await response.json();
        dispatch({ type: 'RECEIVE_EVENTS', events });
    },
    requestEventsTagInstance: (instanceId, tag, days) => async (dispatch, getState) => {       
        
        const headers = { Authorization: `Bearer ${getToken()}` };
        const url = `api/Events/Instance/${instanceId}/${tag}/days/${days}`;
        const response = await fetch(url, {headers});
        if(response.ok){
            const events = await response.json();
            dispatch({ type: 'RECEIVE_EVENTS_INSTANCE_TAG', events });
        } 
    },
     // ADD_EVENT
     addEvent: (newEvent) => async (dispatch, getState) => {
        const headers = { 'Authorization': `Bearer ${getToken()}`,
                            'Content-Type': 'application/json'     
                        };

                        const responseU = await fetch('/api/user/current', { headers });
       await responseU.json().then( async (u) => {
            const user = u.login !== undefined && u.login !== null ? u.login : 'Unknown';
            const url = `api/Events/Acknowledge/${user}`;
        await fetch(url, {
            method: 'post',
            body: JSON.stringify(newEvent),
            headers
        }).then(response => {
            let ev;
            if (response.ok) {
                 ev = response.json();
                 dispatch({ type: 'ADD_EVENT', ev});
                 return ev;
            } 
          });
        });
    },
};




// WEBPACK FOOTER //
// ./src/actions/events.js